import React from 'react'
import PropTypes from 'prop-types'

const InputType = ({ value, onChange, attribute }) => {
  // @TODO: get input props in API.
  attribute.input_props = {
    type: 'text'
  }

  const onInputChange = (e) => {
    onChange(e.target.value)
  }

  return (
    <input
      className="ant-input"
      value={value || ''}
      onChange={onInputChange}
      {...attribute.input_props}
    />
  )
}

InputType.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  attribute: PropTypes.object
}

export default InputType
